import { css } from '@emotion/core'

export const octer = ({ theme: { zIndex, colors } }) => css`
  position: fixed;
  z-index: ${zIndex.dialog};
  height: 100%;
  width: 100%;
  background: ${colors.background};
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  .dialog-view,
  .content {
    height: 100%;
  }

  .dialog-header {
    float: right;
  }
`
export default octer
